<div class="container-style p-2">
  <div class="col d-flex justify-content-end no-print">
    <app-custom-button [title]="'Imprimir'" [icon]="'pi pi-print'" [severity]="'contrast'" (onClick)="printReport()">
    </app-custom-button>
  </div>
  <hr class="my-1 no-print">
  @if (listReports.length === 0) {
  <div class="text-center my-5">
    <i class="pi pi-info-circle text-primary mb-3" style="font-size: 2rem"></i>
    <p class="text-muted">No hay información detallada disponible para este artículo.</p>
  </div>
  }
  @if (listReports.length > 0) {
  <div class="custom-table-container pt-1">
    @for (report of listReports; track $index) {
    <app-custom-table-report [dataReport]="report" [filtersHeight]="0">
    </app-custom-table-report>
    }
  </div>
  }
</div>